import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { capitalize, Skeleton, Tooltip, Typography } from '@mui/material';
import type React from 'react';
import HighlightedFragment from 'src/components/HighlightedText/HighlightedFragment';
import HighlightedText from 'src/components/HighlightedText/HighlightedText';
import { useListViewRowContext } from '../ListViewRowContext';

const NameCell: React.FC<{ slug?: string }> = ({ slug }) => {
  const { loading, rowType, itemId, collection, fieldsBySlug, highlights, highlightTerms, density, handleNavigate } =
    useListViewRowContext();

  if (loading) {
    return <Skeleton variant="text" width="70%" animation="wave" sx={{ fontSize: density.fontSize }} />;
  }

  if (rowType === 'asset') {
    const field = slug ? fieldsBySlug.get(slug) : undefined;
    const osHighlight = field?.slug && highlights?.[field.slug]?.[0];

    const fallbackIcon = field?.fallbackMessage ? (
      <Tooltip title={field.fallbackMessage} arrow>
        <WarningAmberIcon sx={{ fontSize: 14, color: 'text.disabled', ml: 0.5, verticalAlign: 'middle' }} />
      </Tooltip>
    ) : null;

    return (
      // biome-ignore lint/a11y/useKeyWithClickEvents: keyboard navigation handled at table row level
      // biome-ignore lint/a11y/noStaticElementInteractions: keyboard navigation handled at table row level
      <div onClick={() => itemId && handleNavigate(itemId)}>
        <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>
          {osHighlight ? (
            <HighlightedFragment fragment={osHighlight} />
          ) : (
            <HighlightedText
              highlightTexts={[highlightTerms.searchTerm, highlightTerms.hasPhrase, ...highlightTerms.hasWords]}
              text={field?.show ?? ''}
            />
          )}
        </Typography>
        {fallbackIcon}
      </div>
    );
  }

  // rowType === 'collection'
  if (!collection) return null;

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: keyboard navigation handled at table row level
    // biome-ignore lint/a11y/noStaticElementInteractions: keyboard navigation handled at table row level
    <div onClick={() => handleNavigate(collection.id)}>
      <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>
        {capitalize(collection.collectionType)}
        {`: ${collection.name}`}
      </Typography>
    </div>
  );
};

export default NameCell;
